// extracted by mini-css-extract-plugin
module.exports = {"container":"src-modules-user-components-ManageUserProjects---container---J5jFV"};